import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

/** Rooteny brand palette derived from the official logo. */
const rooteny = {
  black: '#000000',
  white: '#FFFFFF',
  electricBlue: '#00AEEF',
  electricBlueDeep: '#0077B3',
  surface: '#0A0A0A',
  paper: '#141414',
  muted: '#A0A0A0',
};

export const rootenyTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      type: 'dark',
      primary: {
        main: rooteny.electricBlue,
        dark: rooteny.electricBlueDeep,
        light: '#4DC8F5',
        contrastText: rooteny.black,
      },
      secondary: {
        main: rooteny.white,
        contrastText: rooteny.black,
      },
      background: {
        default: rooteny.black,
        paper: rooteny.paper,
      },
      text: {
        primary: rooteny.white,
        secondary: rooteny.muted,
      },
      divider: 'rgba(0, 174, 239, 0.25)',
      navigation: {
        background: rooteny.surface,
        indicator: rooteny.electricBlue,
        color: rooteny.muted,
        selectedColor: rooteny.white,
        navItem: {
          hoverBackground: 'rgba(0, 174, 239, 0.12)',
        },
      },
      banner: {
        info: rooteny.electricBlueDeep,
        error: '#8c4351',
        text: rooteny.white,
        link: rooteny.electricBlue,
      },
    },
  }),
  defaultPageTheme: 'home',
  fontFamily:
    '"IBM Plex Sans", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  pageTheme: {
    home: genPageTheme({
      colors: [rooteny.black, rooteny.electricBlueDeep],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: [rooteny.black, rooteny.electricBlue],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: [rooteny.surface, rooteny.electricBlueDeep],
      shape: shapes.round,
    }),
    service: genPageTheme({
      colors: [rooteny.black, rooteny.electricBlue],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: [rooteny.black, rooteny.electricBlueDeep],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: [rooteny.surface, rooteny.electricBlue],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: [rooteny.black, rooteny.electricBlueDeep],
      shape: shapes.wave,
    }),
    app: genPageTheme({
      colors: [rooteny.black, rooteny.electricBlue],
      shape: shapes.wave,
    }),
    apis: genPageTheme({
      colors: [rooteny.surface, rooteny.electricBlueDeep],
      shape: shapes.wave,
    }),
  },
});
